module.exports = __webpack_public_path__ + "img/f5c2f82.png";